import React from 'react';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import About from '../components/About';
import Features from '../components/Features';
import ProductShowcase from '../components/ProductShowcase';
import HowItWorks from '../components/HowItWorks';
import CoverageCalculator from '../components/CoverageCalculator';
import InsuranceGlossary from '../components/InsuranceGlossary';
import CoverageLibrary from '../components/CoverageLibrary';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export const Home = () => {
  return (
    <>
      <SEO 
        title="Symbionic – Making insurance simple and reliable for everyone in Australia, no matter who you insure with"
        description="Symbionic are on a mission to help Australian policyholders unravel the complexities associated with insurance. AI-Powered smart apps like VerifAEye help improve understanding and remove pain points."
        canonical="https://symbionic.com.au/"
      />
      <div className="min-h-screen bg-ink">
        <div className="noise-overlay"></div>
        <Navbar />
        <Hero />
        <Marquee />
        <About />
        <Features />
        <ProductShowcase />
        <HowItWorks />
        <CoverageCalculator />
        <InsuranceGlossary />
        <CoverageLibrary />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default Home;
